import { ProductWishlistChipDetail, ProductWishlistChipDetailConfigurable } from '@graphcommerce/magento-wishlist'
import { Trans } from '@lingui/react'
import { Box, Link } from '@mui/material'
import CustomizeButton from '../../../components/ChipLabCustom/CustomizeButton/CustomizeButton'
import { ConfigurableProductAddToCart } from '../../../components/ChipLabCustom/Configurable/ConfigurableProductAddToCart'
import { useFabSize } from '@graphcommerce/next-ui'
import { ProductSidebarDelivery as SidebarDelivery } from './ProductSidebarDelivery'
import { useContext } from 'react'
import TemplateContext from '../TemplateContext/template-context'
import { AdjustedProductSidebarDelivery } from './AdjustedProductSidebarDelivery'
import { AddProductsToCartButton } from '@graphcommerce/magento-product'
import CustomizeButtonDirect from '../CustomizeButton/CustomizeButtonDirect'


export default function ConfigurableLayout(props) {
  const {
    product,
    disableButton,
    router,
    setDisableButton,
    currentProduct,
    setCurrentProduct,
    hasOne,
    setHasOne,
    isCustomizable,
    isUse,
    currentSku,
    setCurrentSku,
    selected,
    setSelected,
    tetherList,
    by_use_id,
  } = props;

  const fabIconSize = useFabSize('responsive')

  const { quantity } = useContext(TemplateContext);

  return (
    <Box
      sx={{
        position: 'relative'
      }}>
      {hasOne && <>

        <ConfigurableProductAddToCart
          variables={{ sku: product.sku ?? '', quantity: 1 }}
          sku={product?.sku}
          name={product.name ?? ''}
          isCustomizable={isCustomizable}
          optionEndLabels={{
            size: (
              <Link
                component='button'
                color='primary'
                underline='hover'
                onClick={(e) => {
                  e.preventDefault()
                  return router.push('/modal/product/configurable/' + product?.sku)
                }}
              >
                <Trans id='Buy In Bulk & Save!' />
              </Link>
            ),
          }}
          setDisableButton={setDisableButton}
          product={product}
          currentProduct={currentProduct}
          setCurrentProduct={setCurrentProduct}
          setHasOne={setHasOne}
          isUse={isUse}
          currentSku={currentSku}
          setCurrentSku={setCurrentSku}
          selected={selected}
          setSelected={setSelected}
          additionalButtons={<ProductWishlistChipDetailConfigurable {...product} />}
        >
          {isCustomizable ? <SidebarDelivery product={product} quantity={quantity} /> : <AdjustedProductSidebarDelivery product={product} />}
        </ConfigurableProductAddToCart>
        {!disableButton && <CustomizeButton tetherList={tetherList} by_use_id={by_use_id} currentSku={currentSku} product={product} sx={(theme) => ({
          zIndex: theme.zIndex.appBar - 1,
          marginTop: theme.spacings.sm,
          marginBottom: theme.spacings.sm,
          width: '100%',
          display: 'flex',
          marginX: 'auto',
          position: 'sticky',
          bottom: 20,
          top: 20,
          [theme.breakpoints.down('md')]: {
            width: `calc(100% - (2 * ${fabIconSize}) - 30px)`
          },
          '@media (max-height: 530px) and (orientation: portrait)': {
            display: 'none',
          },
        })} />}
        {disableButton && <CustomizeButton by_use_id={by_use_id} currentSku={currentSku} product={product} tetherList={tetherList} disabled sx={(theme) => ({
          marginTop: theme.spacings.sm,
          marginBottom: theme.spacings.sm,
          width: '100%'
        })} />}
      </>}
      {!hasOne && <>
        <ConfigurableProductAddToCart
          variables={{ sku: product.sku ?? '', quantity: 1 }}
          sku={product?.sku}
          name={product.name ?? ''}
          isCustomizable={isCustomizable}
          optionEndLabels={{
            size: (
              <Link
                component='button'
                color='primary'
                underline='hover'
                onClick={(e) => {
                  e.preventDefault()
                  return router.push('/modal/product/configurable/' + product?.sku)
                }}
              >
                <Trans id='Buy In Bulk & Save!' />
              </Link>
            ),
          }}
          setDisableButton={setDisableButton}
          product={product}
          currentProduct={currentProduct}
          setCurrentProduct={setCurrentProduct}
          setHasOne={setHasOne}
          isUse={isUse}
          currentSku={currentSku}
          setCurrentSku={setCurrentSku}
          selected={selected}
          setSelected={setSelected}
          additionalButtons={<ProductWishlistChipDetailConfigurable {...product} />}
        >
          {isCustomizable ? <SidebarDelivery product={product} quantity={quantity} /> : <AdjustedProductSidebarDelivery product={product} />}
        </ConfigurableProductAddToCart>
        {!disableButton && <CustomizeButton tetherList={tetherList} by_use_id={by_use_id} currentSku={currentSku} product={product} sx={(theme) => ({
          zIndex: theme.zIndex.appBar - 1,
          marginTop: theme.spacings.sm,
          marginBottom: theme.spacings.sm,
          width: '100%',
          display: 'flex',
          marginX: 'auto',
          position: 'sticky',
          bottom: 20,
          top: 20,
          [theme.breakpoints.down('md')]: {
            width: `calc(100% - (2 * ${fabIconSize}) - 30px)`
          },
          '@media (max-height: 530px) and (orientation: portrait)': {
            display: 'none',
          },
        })} />}
        {disableButton && <CustomizeButton by_use_id={by_use_id} currentSku={currentSku} product={product} tetherList={tetherList} disabled sx={(theme) => ({
          marginTop: theme.spacings.sm,
          marginBottom: theme.spacings.sm,
          width: '100%'
        })} />}
      </>}
    </Box>
  )
}
